<template>
  <a
    :class="classes"
    :href="linkHref"
    :target="linkTarget"
    @touchend="$dn.blurActiveElement"
    @mouseup="$dn.blurActiveElement"
    @click="onClick"
  >
    <dn-icon v-if="iconLeft" class="dn-btn__icon dn-btn__icon--left" :icon="iconLeft" />
    <dn-icon v-if="icon" class="dn-btn__icon dn-btn__icon--center" :icon="icon" />
    <slot />
    <dn-icon v-if="iconRight" class="dn-btn__icon dn-btn__icon--right" :icon="iconRight" />
    <div class="dn-btn__content" v-if="hasContent">
      <slot name="content" />
    </div>
  </a>
</template>



<script>
import Linkset from 'ui/mixins/linkset';



export default {
  mixins: [Linkset],



  props: {

    // color
    plain: Boolean,
    flat: Boolean,
    primary: Boolean,
    accent: Boolean,
    strong: Boolean,

    // size
    sm: Boolean,
    lg: Boolean,
    icon: String,
    block: Boolean,
    blockPc: Boolean,
    blockSp: Boolean,

    // width
    widthLg: Boolean,
    widthLgPc: Boolean,
    widthLgSp: Boolean,

    // font size
    textLg: Boolean,

    // icon
    iconLeft: String,
    iconRight: String,

    // control
    autofocus: Boolean,
  },



  computed: {
    classes() {
      return {
        'dn-btn': true,
        'dn-btn--plain': this.plain,
        'dn-btn--flat': this.flat,
        'dn-btn--primary': this.primary,
        'dn-btn--accent': this.accent,
        'dn-btn--strong': this.strong,
        'dn-btn--disabled': this.linkIsDisabled,
        'dn-btn--sm': this.sm,
        'dn-btn--lg': this.lg,
        'dn-btn--icon': !!this.icon,
        'dn-btn--block': this.block,
        'dn-btn--block-pc': this.blockPc,
        'dn-btn--block-sp': this.blockSp,
        'dn-btn--width-lg': this.widthLg,
        'dn-btn--width-lg-pc': this.widthLgPc,
        'dn-btn--width-lg-sp': this.widthLgSp,
        'dn-btn--text-lg': this.textLg,
        'dn-btn--has-icon': this.hasIcon,
        'dn-btn--has-content': this.hasContent,
      }
    },

    hasContent() { return this.$slots.content !== undefined },

    // flags
    hasIcon() { return (this.iconLeft !== undefined || this.iconRight !== undefined) },

    // values
    iconPosition() {
      if (this.iconLeft) return 'left';
      if (this.iconRight) return 'right';
    },
  },

  methods: {
    onClick(e) {
      if (this.linkIsDisabled) {
        e.preventDefault();
        return;
      }

      this.$emit('click', e);
    },

    focus() {
      this.$el.focus();
    },
  },

  mounted() {
    if (this.autofocus) this.focus();
  },
}
</script>


// WEBPACK FOOTER //
// Btn.vue?252ef8f8